(function () {
  'use strict';
  angular.module('MktzapApp.Directives')
    .directive('nwDatePicker', function () {
      return {
        require: 'ngModel',
        scope: {
          ngModel: '=',
          ngChange: '&',
          nwFormat: '=',
          nwSeparator: '=',
          nwLanguage: '=',
          nwStartDate: '=',
          nwEndDate: '=',
          nwAutoClose: '='
        },
        link: function (scope, element, attrs, controller) {
          scope.turnIntoMoment = function (value) {
            if (value !== undefined) {
              if (value !== null) {
                if (!moment.isMoment(value)) {
                  if (value.indexOf('-') != -1) {
                    var momentum = moment(value, 'YYYY-MM-DD');
                  } else {
                    var momentum = moment(value, 'DD/MM/YYYY');
                  }
                } else {
                  return value;
                }
              } else {
                var momentum = value;
              }
            } else {
              var momentum = value;
            }
            return momentum;
          }

          controller.$formatters.push(function (modelValue) {
            if (modelValue === undefined) { return modelValue; }
            if (modelValue === null) { return modelValue; }
            if (modelValue === 'Invalid date') { return null; }
            return scope.turnIntoMoment(modelValue).format('DD/MM/YYYY');
          });

          scope.$watch('ngModel', function (viewValue) {
            if (viewValue !== undefined) {
              if (viewValue !== null) {
                controller.$setViewValue(scope.turnIntoMoment(viewValue).format('DD/MM/YYYY'));
              }
            }
          })

          controller.$parsers.push(function (viewValue) {
            if (viewValue === undefined) {
              return null;
            }
            if (viewValue === '') {
              return null;
            }
            if (viewValue === 'Invalid date') { return null; }
            return scope.turnIntoMoment(viewValue).format('YYYY-MM-DD');
          });

          var configObject = {
            format: scope.nwFormat,
            separator: scope.nwSeparator,
            language: scope.nwLanguage,
            startDate: scope.nwStartDate,
            endDate: scope.nwEndDate,
            singleDate: true,
            singleMonth: true,
            autoClose: scope.nwAutoClose,
            hoveringTooltip: false,
            autoClose: false,
            applyBtnClass: 'button success',
            alwaysOpen: false,
            dayHovering: function () {}
          }

          element.dateRangePicker(configObject);
          element.bind('datepicker-change', function (obj, e) {
            scope.ngModel = scope.turnIntoMoment(e.value).format('YYYY-MM-DD');
            scope.$apply();
            scope.ngChange();
          })
        }
      }
    });
})();
